function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "led");

var SvgLed = function SvgLed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ff05d318-4905-46a9-b26b-7d288b5ed2ed",
    "data-name": "Ebene 1",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "a14601e0-2e74-42ad-b122-d6003cb4219c",
    "data-name": "Page-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ecfc9c72-82b2-4223-8db7-48bd91af043d",
    "data-name": "Shape",
    d: "M335.75,33.06a112.81,112.81,0,0,0-192.56,79.75V295.05H368.81V112.81A112.47,112.47,0,0,0,335.75,33.06Z",
    style: {
      fill: "#e64c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.42,251.66H284.13a8.68,8.68,0,0,1-7.5-13l20.25-34.71a8.7,8.7,0,0,1,7.49-4.34h12.38a8.68,8.68,0,0,1,8.67,8.68Z",
    style: {
      fill: "#c03a2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.61,56.58a8.68,8.68,0,0,1-4.84-15.89A86.29,86.29,0,0,1,256,26a8.68,8.68,0,1,1,0,17.36,69,69,0,0,0-38.56,11.72A8.66,8.66,0,0,1,212.61,56.58Z",
    style: {
      fill: "#fb7b76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.9,121.49a8.68,8.68,0,0,1-8.68-8.68,85.74,85.74,0,0,1,9.06-38.59A8.68,8.68,0,1,1,193.81,82a68.65,68.65,0,0,0-7.23,30.84,8.69,8.69,0,0,1-8.68,8.68Z",
    style: {
      fill: "#fb7b76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.75,303.73a8.68,8.68,0,0,1-8.68-8.68V251.66a8.68,8.68,0,1,1,17.35,0v43.39A8.68,8.68,0,0,1,316.75,303.73Z",
    style: {
      fill: "#c03a2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.25,303.73a8.68,8.68,0,0,1-8.67-8.68V251.66a8.68,8.68,0,1,1,17.35,0v43.39A8.68,8.68,0,0,1,195.25,303.73Z",
    style: {
      fill: "#c03a2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.37,212.61l-20.25,34.71a8.68,8.68,0,0,1-7.49,4.34h-21V208.27a8.68,8.68,0,0,1,8.67-8.68h32.62a8.68,8.68,0,0,1,7.5,13Z",
    style: {
      fill: "#c03a2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.25,512a8.68,8.68,0,0,1-8.67-8.68V373.15a8.68,8.68,0,1,1,17.35,0V503.32A8.68,8.68,0,0,1,195.25,512Z",
    style: {
      fill: "#f29c1f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.75,512a8.68,8.68,0,0,1-8.68-8.68V373.15a8.68,8.68,0,1,1,17.35,0V503.32A8.68,8.68,0,0,1,316.75,512Z",
    style: {
      fill: "#f29c1f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "fea6bb6b-0b2c-439a-bb60-bee5f3d65200",
    "data-name": "Rectangle-path",
    x: 117.15,
    y: 295.05,
    width: 277.69,
    height: 43.39,
    rx: 8.68,
    style: {
      fill: "#f29c1f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.22,338.44h52.07V355.8a17.35,17.35,0,0,1-17.36,17.35H186.58a17.35,17.35,0,0,1-17.36-17.35Z",
    style: {
      fill: "#f0c419"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.71,338.44h52.07V355.8a17.35,17.35,0,0,1-17.36,17.35H308.07a17.35,17.35,0,0,1-17.36-17.35Z",
    style: {
      fill: "#f0c419"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/led.7f027b1c.svg";
export { ForwardRef as ReactComponent };